import { AxiosResponse } from 'axios';
import { getApiUrl } from '../util/util';
import { get, post } from './http';

export interface SearchTermRequest {
	searchTerm: string;
	fieldName?: string;
	match?: 'exact' | 'startsWith' | 'fuzzy';
	absolute?: 'none' | 'required' | 'excluded';
}

export type SearchReturnType =
	| ''
	| 'policyholder'
	| 'policy'
	| 'claim'
	| 'payment'
	| 'quote'
	| 'premium_report';

export interface SearchRequest {
	searchString?: string;
	returnType?: SearchReturnType;
	products?: string[];
}

export interface SearchResponse {
	searchToken: string;
	pageNumber: string;
	results: SearchResultResponse[];
}

export interface SearchResultResponse {
	// Required
	type: SearchReturnType;
	score: number;
	policyholderLocator: string;
	policyLocator?: string;
	quoteLocator?: string;
	claimLocator?: string;
	paymentLocator?: string;
	premiumReportLocator?: string;
	subclaimLocator: string;
	paymentDisplayId?: string;
	searchSummary: [SearchSummaryItemResponse];
}

export interface SearchSummaryItemResponse {
	fieldName: string;
	fieldType: string;
	fieldValue: [string];
}

interface CoreSearchApi {
	coreSearch(
		authorizationToken: string,
		params: SearchRequest,
	): Promise<AxiosResponse<SearchResponse>>;
	coreSearchByPage(
		authorizationToken: string,
		searchToken: string,
		pageNumber: string,
	): Promise<AxiosResponse<SearchResponse>>;
}

export default {
	coreSearch(authorizationToken: string, params: SearchRequest) {
		return post(`${getApiUrl()}/search`, authorizationToken, params);
	},
	coreSearchByPage(
		authorizationToken: string,
		searchToken: string,
		pageNumber: string,
	) {
		return get(
			`${getApiUrl()}/search/${searchToken}/${pageNumber}`,
			authorizationToken,
		);
	},
} as CoreSearchApi;
